import m from 'mithril'
import { appIcons } from '../../lib/icons'


export default {
  oninit(vnode) {
    vnode.state.open = false
    vnode.state.allowAnyway = false
  },
  toggle() {
    if ( this.allowAnyway ) {
      // Do nothing; checkbox needs to stay in DOM
    }
    else {
      this.open = ! this.open
    }
  },
  view({ state, attrs }) {
    var {client, details, allowFuture} = attrs

    var label, icon

    //
    // TODO: Handle read-only and write-only scopes
    //
    if ( ! details.isForeign ) {
      icon = "👍"
      label = "Read & Write its own data"
    }
    else {
      icon = details.valid
        ? m('.tooltip[data-tooltip="Please consider the security of this request!"]',
            "🤔",
            m('.icon', appIcons[details.metacategoryIcon]
              ? m('.icon', appIcons[details.metacategoryIcon])
              : null
            ),
          )
        : details.installed
          ? m('.tooltip.text-error[data-tooltip="This request is invalid."]', "⁉")
          : m('.tooltip[data-tooltip="This app is not installed."]', "🚫")
      label = ["Read & Write", m('br'), m('b',details.meta.name), " app data"]
    }

    var showDescription = state.open && details.valid

    return m('.tile.bg-gray.mb-1.p-2',
      { style: `border: 1px solid #ccc; flex: 1 0 auto` },
      m('.tile-icon', icon),
      m('.tile-content.flex',
        m('.tile-title', label),
        m('.tile-subtitle.text-gray', details.host),

        ! details.isForeign &&
        m('.pt-2', details.meta.description),

        details.isForeign && (
          details.installed
            ? m('.text-success',
                "You are granting access to this already-installed app. Be careful!"
              )
            : m('.text-error', "Not Installed")
        ),

        // Use .hhide to avoid janky width changes
        m('.pt-2', { class: state.open ? '' : 'hhide' },

          details.valid ? [
            m('div', details.meta.description),
          ] : [
            m('.toast',
              "Because this app is not installed, ",
              m('b', client.meta.name),
              " will not be granted access to this app."
            ),

            allowFuture &&
            m('.form-group',
              m('label.form-checkbox',
                m('input[type=checkbox]', {
                  name: `allow_future[${encodeURIComponent(details.scope)}]`,
                  value: state.allowAnyway,
                  onchange: e => state.allowAnyway = e.target.checked,
                }),
                m('i.form-icon'),
                m('span', `Grant access to future installs of ${details.meta.name} (this doesn't do anything yet)`)
              )
            ),
          ],
        )
      ),

      details.isForeign &&
        m('.tile-action',
          m('button[type=button].btn.btn-sm', {
            disabled: state.allowAnyway,
            style: `width: 3.75rem;`,
            onclick: () => state.toggle()
          }, state.open ? "Close" : "Details")
        )
    )
  }
}